"use strict";

exports.__esModule = true;
exports.AvatarDefault = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SaladAvatar = _interopRequireDefault(require("./assets/SaladAvatar.png"));
var _Avatar = require("./Avatar");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AvatarDefault = function AvatarDefault(_ref) {
  var avatarSize = _ref.avatarSize,
    onClick = _ref.onClick,
    variant = _ref.variant;
  return (0, _jsxRuntime.jsx)(_Avatar.Avatar, {
    avatarSize: avatarSize,
    alt: "Salad Avatar",
    src: _SaladAvatar.default,
    onClick: onClick,
    variant: variant
  });
};
exports.AvatarDefault = AvatarDefault;
AvatarDefault.propTypes = {
  avatarSize: _propTypes.default.number,
  onClick: _propTypes.default.func,
  variant: _propTypes.default.oneOf(['highlighted', 'pulse', 'error', 'outlined'])
};